<div class="machine-details-card">
  <div class="d-flex align-items-center g-g">
    <oaibox-custom-i class="machine-icon" icon="box-inverted" iconsBasePath="assets/icons/duotone"></oaibox-custom-i>
    <div class="flex-fill">
      <div>{{ machine?.productDetails?.oaiboxType }}</div>
      <div class="machine-id" [oaiboxCopy]="machine?.id">{{ machine?.id }}</div>
      <div class="machine-id" [oaiboxCopy]="machine?.oaiboxSerialNumber">{{ machine?.oaiboxSerialNumber }}</div>
    </div>
  </div>

  <div class="h-divider"></div>

  <div class="d-flex justify-content-between g-g">
    <div class="pill-wrapper">
      <div class="list-title">Fronthaul Type</div>
      <div class="pill">
        {{ (machine?.productDetails?.fronthaulType| fronthaulConfig)?.label }}
      </div>
    </div>

    <div class="pill-wrapper">
      <div class="list-title">Frequency Range</div>
      <div class="pill">
        {{ machine?.productDetails?.frequencyRange }}
      </div>
    </div>

    <div class="pill-wrapper">
      <div class="list-title">Duplex Mode</div>
      <div class="pill">
        {{ machine?.productDetails?.duplexMode }}
      </div>
    </div>

    <div class="flag">
      <div class="list-title">PTP Configuration</div>
      <div>{{ machine?.productDetails?.ptpConfiguration?.interfaceName ?? 'interface name'}}</div>
      <span class="flag-state" [class.disabled]="!machine?.productDetails?.ptpConfiguration?.enabled">{{
        machine?.productDetails?.ptpConfiguration?.enabled ? 'Enabled' : 'Disabled' }}</span>
    </div>
  </div>
</div>
